"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ChevronDown = (0, _createIcon["default"])({
  path: 'M8 9.47759L13.2049 4.30602C13.6156 3.89799 14.2814 3.89799 14.692 4.30602C15.1027 4.71405 15.1027 5.37559 14.692 5.78361L8.74356 11.694C8.3329 12.102 7.6671 12.102 7.25644 11.694L1.30799 5.78361C0.897336 5.37559 0.897336 4.71405 1.30799 4.30602C1.71865 3.89799 2.38445 3.89799 2.7951 4.30602L8 9.47759Z',
  // prettier-ignore
  viewBox: '16 16',
  icon: 'chevronDown',
  displayName: 'ChevronDown'
});
var _default = exports["default"] = ChevronDown;